import { CloseIcon } from '@svgs'
import React, { FC } from 'react'
import MyModal, { IMyModal } from 'src/components/ui/modal/MyModal'
import { INewsCard } from 'src/components/pages/home/sections/news/NewsSection'

interface INewsModal extends IMyModal {
  news: INewsCard | null
}

const NewsModal: FC<INewsModal> = ({ open, handleClose, news }) => {
  if (!news) return null

  return (
    <MyModal
      showClose={false}
      width="w-[calc(100%_-_2rem)] md:w-[50rem]"
      contentClassName="!p-0"
      open={open}
      handleClose={handleClose}
    >
      <div className="flex flex-col">
        <button
          onClick={() => handleClose()}
          className="icon-button fill-white hover:fill-white/80 absolute z-20 top-4 right-4 w-6 h-6 drop-shadow-lg"
        >
          <CloseIcon />
        </button>

        {/* News Image */}
        <div className="relative w-full h-64 md:h-80 overflow-hidden rounded-t-2xl">
          <img src={news.image} alt={news.title} className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
          <h2 className="absolute bottom-6 left-6 right-6 text-2xl md:text-3xl font-black text-white leading-tight">
            {news.title}
          </h2>
        </div>

        {/* News Content */}
        <div className="p-6 md:p-8">
          <div className="prose prose-slate max-w-none">
            <p className="text-base md:text-lg text-ink-2 leading-relaxed">{news.description}</p>

            {/* Without a full text the short description used to be printed twice */}
            {news.fullContent && news.fullContent !== news.description && (
              <div className="mt-6 space-y-4">
                <p className="text-ink-2 whitespace-pre-line">{news.fullContent}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </MyModal>
  )
}

export default NewsModal
